<!--
	Wrapper component: renderless. The script owns state and the rotation timer; the template
	only exposes them through a scoped slot and renders no markup of its own. Twig owns every
	line of markup inside <review-carousel …> and binds to the slot props with
	v-slot="{ … }", v-show, :class, and @click. Inputs arrive as kebab-case attributes on the tag.
-->
<template>
	<slot v-bind="{ index, fading, next, prev, go }" />
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from "vue";

const props = defineProps({
	count: {
		type: Number,
		required: true,
	},
	// Milliseconds between automatic slides
	interval: {
		type: Number,
		default: 5000,
	},
});

// Length of the fade out, in milliseconds. Matches duration-200 on the slides container.
const FADE_MS = 200;

const index = ref(0);
const fading = ref(false);

let timer = null;
let fadeTimer = null;

function swap(target) {
	if (props.count < 2) {
		return;
	}

	clearTimeout(fadeTimer);
	fading.value = true;

	fadeTimer = setTimeout(() => {
		index.value = target;
		fading.value = false;
	}, FADE_MS);
}

function advance() {
	swap((index.value + 1) % props.count);
}

// A manual action restarts the timer so the click is not overridden a moment later
function next() {
	advance();
	start();
}

function prev() {
	swap((index.value - 1 + props.count) % props.count);
	start();
}

function go(i) {
	if (i === index.value) {
		return;
	}

	swap(i);
	start();
}

function start() {
	stop();
	timer = setInterval(advance, props.interval);
}

function stop() {
	clearInterval(timer);
	timer = null;
}

onMounted(start);

onBeforeUnmount(() => {
	stop();
	clearTimeout(fadeTimer);
});
</script>
